import { getFileSizeInKb, getImageTypeFromBase64String, parseBase64Data } from './image'
import { getErrorMessage } from './data'

// Checks a picked avatar (a data URL) before upload: jpg / png only, passes
// image moderation (gcp-image-moderate), under 5MB.
export const validateAvatar = async (base64string: string) => {
  const image = base64string
  const type = getImageTypeFromBase64String(image)

  if (type !== 'jpeg' && type !== 'jpg' && type !== 'png') {
    return {
      valid: false,
      reason: 'Not a valid file type. Must be a .jpg or .png'
    }
  }

  const imageString = parseBase64Data(image)
  const appropriateCheck = await fetch(`/.netlify/functions/gcp-image-moderate`, {
    method: 'POST',
    body: JSON.stringify({
      image: imageString
    })
  })

  const data = await appropriateCheck.json()

  if (!data.success) {
    return {
      valid: false,
      reason: getErrorMessage(data, 'Uploaded image must not contain violent or adult content.')
    }
  }

  const sizeInKb = getFileSizeInKb(imageString, type)

  if (sizeInKb >= 5000) {
    return {
      valid: false,
      reason: 'Uploaded image must be below 5mb'
    }
  }
  return { valid: true }
}
